<template>
  <div>
    <top-img-temp
      :imgUrl="topImg ? topImg : topImg2"
      :cName="cName"
      :e-name="eName"
      :c-text="cText"
      :e-text="eText"
    ></top-img-temp>
    <div class="section2">
      <div class="bbTitl">
        {{ isChinese ? "热浸锌产品系列" : "Hot-dip Galvanized Products" }}
      </div>
      <p class="bbText">
        {{
          isChinese
            ? "计氏拥有对热浸锌行业20余年的处理经验。"
            : "Jishi has more than 20 years of experience in hot-dip galvanizing industry."
        }}
      </p>

      <div class="section2_box">
        <div
          v-if="section2List && section2List.length == 1"
          class="section2_box_1"
          @click="gotoDetail(section2List[0].id, section2List[0])"
        >
          <div>
            <img :src="section2List[0].cover" alt />
          </div>
          <div class="block">
            <div class="block_1">
              <img :src="section2List[0].imgPath" alt />
            </div>
            <p class="block_2">
              {{
                isChinese ? section2List[0].simple : section2List[0].simpleEn
              }}
            </p>
            <div class="block_3">
              <p>
                {{
                  isChinese ? section2List[0].title : section2List[0].titleEn
                }}
              </p>
              <p class="el-icon-caret-right"></p>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="innderSection3_1">
            <div
              v-for="(item, index) in section2List"
              :key="index"
              @click="gotoDetail(item.id, item)"
              class="innderSection3_2"
            >
              <div>
                <img :src="item.cover" alt />
              </div>
              <!--  hover之后的效果 -->
              <div class="block">
                <div class="block_1">
                  <img :src="item.imgPath" alt />
                </div>
                <p class="block_2">
                  {{ isChinese ? item.simple : item.simpleEn }}
                </p>
                <div class="block_3">
                  <p>{{ isChinese ? item.title : item.titleEn }}</p>
                  <p class="el-icon-caret-right"></p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="section3">
      <div class="bbTitl">
        {{ isChinese ? "锌铝涂覆产品系列" : "Zinc-flake Coating Products" }}
      </div>
      <p class="bbText">
        {{
          isChinese
            ? "锌铝涂层是由重叠的多层金属薄片通过无机粘结剂重合在一起，可以与紧固件很好的契合，广泛运用于汽车、重卡、再生能源等行业上。"
            : "Zinc-flake coating is composed of overlapping multi-layer metal sheets overlapped by inorganic binder. The products can fit well with fasteners. Therefore, the products can be widely used in automobile, heavy truck, renewable energy and other industries."
        }}
      </p>

      <div class="innderSection3">
        <div class="innderSection3_1">
          <div
            v-for="(item, index) in section3List"
            :key="index"
            @click="gotoDetail(item.id, item)"
            class="innderSection3_2"
          >
            <div>
              <img :src="item.cover" alt />
            </div>
            <!--  hover之后的效果 -->
            <div class="block">
              <div class="block_1">
                <img :src="item.imgPath" alt />
              </div>
              <p class="block_2">
                {{ isChinese ? item.simple : item.simpleEn }}
              </p>
              <div class="block_3">
                <p>{{ isChinese ? item.title : item.titleEn }}</p>
                <p class="el-icon-caret-right"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section4">
      <p class="bbTitl">{{ isChinese ? "应用领域" : "Applications" }}</p>
      <p class="bbText">
        {{
          isChinese
            ? "应用产品广泛，为您提供全方位专业化服务"
            : "Widely applied to provide you with a full range of professional services"
        }}
      </p>
      <div style="height: 5vw"></div>
      <yyly-temp></yyly-temp>
    </div>
  </div>
</template>

<script>
import topImgTemp from "./baseTemp/topImgTemp";
import yylyTemp from "./baseTemp/yylyTemp";

export default {
  name: "solution",
  data() {
    return {
      isChinese: undefined,
      cName: "解决方案",
      eName: "Solution",
      cText: "针对客户要求而经过优化的应用解决方案",
      eText: "Application solutions optimized for customer requirements",
      topImg: "",
      topImg2: require("../../static/images/solution/JYFA-09.jpg"),
      section2List: [],
      section3List: [],
    };
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    },
  },

  watch: {
    // 监听 切换中英文
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
    },
  },
  created() {
    this.getAllPro();
    this.getTopImg();
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
  },
  components: { topImgTemp, yylyTemp },
  methods: {
    getAllPro() {
      this.$http.get("/jishi/api/case/all").then(
        function (res) {
          if (res && res.data.code === 0) {
            let resdata = res.data.data;
            this.section2List = resdata[0];
            this.section3List = resdata[1];
          }
        }.bind(this)
      );
    },
    gotoDetail(id, item) {
      let routeData = this.$router.resolve({
        path: "/solutionMore" + "/id=" + id,
        query: { title: item.title },
      });
      window.open(routeData.href, "_blank");
    },
    getTopImg() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "解决方案-顶部图片",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              // this.section2List = resdata[0]
              // this.section3List = resdata[1]
              this.topImg = resdata.logo;
            }
          }.bind(this)
        );
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
}
.section2,
.section3 {
  margin-top: 5vw;
}
.bbTitl {
  text-align: center;
  color: #595757;
  font-size: 3rem;
  font-family: Medium;
}
.bbText {
  width: 45%;
  margin: 0 auto;
  text-align: center;
  /* color: #787878; */
  color: black;
  margin-top: 2vw;
  font-size: 18px;
  line-height: 30px;
  font-family: "Light";
}
.section2_box {
  width: 100%;
  background: #f7f7f7;
  padding-bottom: 4vw;
  margin-top: 3vw;
}
.section2_box > div {
  width: 60%;
  margin: 0 auto;
}
.innderSection3 {
  width: 70%;
  margin: 0 auto;
  margin-top: 3vw;
}
.innderSection3_1 {
  display: flex;
  flex-flow: wrap;
  cursor: pointer;
}
.innderSection3_2 {
  position: relative;
  width: 48%;
  margin-left: 2%;
  margin-top: 2%;
}
.section2_box_1 {
  position: relative;
}
.section2_box_1:hover .block {
  display: block;
}
.innderSection3_2:hover .block {
  display: block;
}
@media screen and (max-width: 1100px) {
  /*.innderSection3_2:hover .block {*/
  /*display: none;*/
  /*}*/
  .innderSection3_1 {
    display: block;
  }
  .innderSection3_2 {
    width: 95%;
    margin: 0 auto;
    margin-top: 10px;
    overflow: hidden;
  }
}
@media screen and (max-width: 800px) {
  .bbText {
    width: auto;
    margin: 0 10px;
    margin-top: 2vw;
    font-size: 14px;
    line-height: 20px;
    
  }
  .section2_box_1:hover .block {
  display: none;
}
.innderSection3_2:hover .block {
  display: none;
}

  .section4 {
    display: none;
  }
  .section2_box > div {
  width: 95%;
}
  .innderSection3{
  width: 100%;
}
.innderSection3_2 {
  margin-top: 1%;
}
}
.block {
  display: none;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.block_1 {
  width: 26%;
  padding: 20px 30px 20px 20px;
}
.block_2 {
  color: #dfdfdf;
  padding: 0px 20px;
  line-height: 30px;
  font-size: 15px;
}
.block_3 {
  position: absolute;
  font-size: 15px;
  width: 100%;
  height: 40px;
  bottom: 0;
  color: white;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.block_3 > p:nth-child(1) {
  color: white;
  margin-right: 3px;
}
.block_3 > p:nth-child(2) {
  color: #e7a600;
  margin-right: 20px;
  font-size: 17px;
}
.section4 {
  background: #f4f4f5;
  margin-top: 8vw;
  padding-top: 10vw;
  padding-bottom: 5vw;
  margin-bottom: 8vw;
}
</style>



// WEBPACK FOOTER //
// src/components/solution.vue